import React from 'react';
import NewsPanel from '../newsPagePanel/newsPagePanel';


const recentNews = [

    {id: 14,
        title: 'Brain-inspired AI architecture could compute faster while using far less power.',
        content: "Described as a game changer for AI accessibility and performance, ASI-1 Mini is heralded for delivering results on par with leading LLMs but at significantly reduced hardware costs—a leap forward in making AI enterprise-ready.",
        image: "https://scx1.b-cdn.net/csz/news/800a/2026/new-brain-inspired-arc-1.jpg",
        link: "https://techxplore.com/news/2026-06-brain-ai-architecture-faster-power.html",
        comment: ''},
    {id: 13,
        title: 'OpenHands: Open Source AI Software Developer',
        content: "Build, test, and deploy a complete application in minutes — just by chatting with OpenHands.",
        image: "https://www.kdnuggets.com/wp-content/uploads/awan_openhands_open_source_ai_software_developer_3.png",
        link: "https://www.kdnuggets.com/openhands-open-source-ai-software-developer",
        comment: ''},

    {id: 12,
        title: 'OpenAI and Broadcom unveil LLM-optimized inference chip',
        content: "OpenAI and Broadcom (NASDAQ: AVGO) today unveiled Jalapeño, OpenAI’s first Intelligence Processor: an accelerator architected around OpenAI’s vision for the future of LLM inference, and the first AI accelerator in a multi-generation compute platform the companies are building together to make advanced AI faster, more reliable, and more accessible to more people.",
        image: "https://images.ctfassets.net/kftzwdyauwt9/4AoGW0ZsC0SxSCXYRBEwnj/fa523eda9466c6dd401e38c6c0396906/openai-broadcom-jalapeno-inference-chip-image.png?w=1920&q=90&fm=webp",
        link: "https://openai.com/index/openai-broadcom-jalapeno-inference-chip/",
        comment: ''},
    {id: 11,
        title: 'The AI shift in cyber risk: why leaders must act now',
        content: "Frontier Al models are anticipated to exceed current industry expectations, fundamentally transforming both offensive and defensive cyber capabilities. The timeline is not years, it is months.",
        image: "https://www.cyber.gov.au/sites/default/files/2026-06/five-eyes-logo-large.png",
        link: "https://www.cyber.gov.au/about-us/view-all-content/news/five-eyes-cyber-security-agencies-statement",
        comment: ''},
    {id: 10,
        title: 'Meta releases Llama 4',
        content: "The Llama 4 Models are a collection of pretrained and instruction-tuned mixture-of-experts LLMs offered in two sizes: Llama 4 Scout & Llama 4 Maverick. These models are optimized for multimodal understanding, multilingual tasks, coding, tool-calling, and powering agentic systems. The models have a knowledge cutoff of August 2024.",
        image: "https://github.com/meta-llama/llama3/blob/main/Llama3_Repo.jpeg?raw=true",
        link: "https://llama.meta.com/llama4/",
        comment: ''},
    {id: 9,
        title: 'Microsoft acquires Inflection',
        content: "Microsoft Corp. has agreed to pay Inflection AI $650 million, largely to license its artificial intelligence software, alongside its move earlier this week to hire much of the startup’s staff.",
        image: "https://assets.bwbx.io/images/users/iqjWHBFdfxIU/isqJhk05l_JE/v1/1200x800.jpg",
        link:'https://www.bloomberg.com/news/articles/2024-03-21/microsoft-to-pay-inflection-ai-650-million-after-scooping-up-most-of-staff',
        comment: ''},
    {id: 8,
        title: 'TensorFlow 2.21.0 Released',
        content: "Support for Python 3.9 has been removed starting with TF 2.21.",
        image: "https://storage.googleapis.com/gweb-cloudblog-publish/images/Google_Cloud_TensorFlow_Enterprise_1.max-1100x1100.jpg",
        link: "https://github.com/tensorflow/tensorflow/releases",
        comment: ''},
    {id: 7,
        title: 'OpenAI Introducing LifeSciBench',
        content: "Agentic AI systems are becoming increasingly capable of performing scientific tasks. However, their usefulness to life science researchers depends on how well they handle the complexity of real research. ",
        image: "https://images.ctfassets.net/kftzwdyauwt9/3pF3WvB19yWAPaKfGfxtps/24954138f2850e7a9623d5aa989de59e/Diagram1-desktop-dark.svg?w=3840&q=80",
        link:'https://openai.com/index/introducing-life-sci-bench/',
        comment: ''},
    {id: 6,
        title: 'AI Cracks the Secrets of How the Universe’s Heaviest Elements Are Forged',
        content: "A machine learning-powered simulation is giving researchers a new window into the processes that create some of the universe’s heaviest elements.",
        image: "https://scitechdaily.com/images/Neutron-Star-Merger-4-777x590.jpg",
        link:'https://scitechdaily.com/ai-cracks-the-secrets-of-how-the-universes-heaviest-elements-are-forged/',
        comment: ''},
    {id: 5,
        title: 'WeatherNext 2',
        content: "WeatherNext 2 is the state-of-the-art family of weather forecasting models from Google DeepMind and Google Research",
        image: '/images/general/panel-default-image.svg',
        link:'https://deepmind.google/discover/blog/alphaproteo-generates-novel-proteins-for-biology-and-health-research/',
        comment: ''},
    // {id: 4,
    //     title: 'The Impact of AI and Machine Learning on Startup Innovation',
    //     content: "In the current fast-paced and ever-changing business environment, startups are continuously searching for creative methods to establish a competitive advantage.",
    //     image: "https://www.healthcareitnews.com/sites/hitn/files/Vaccination.jpg",
    //     link:"https://techround.io/startups/impact-ai-machine-startup-innovation/"},
    // {id: 3,
    //     title: 'Automation and machine learning future of stem cell production, experts say',
    //     content: "Health leaders have highlighted how digital advancements could give patients streamlined access to life-saving stem cell treatments.",
    //     image: 'https://www.healthcareitnews.com/sites/hitn/files/Artificial%20Intelligence%203_0.jpg',
    //     link:'https://www.nationalhealthexecutive.com/articles/automation-and-machine-learning-future-stem-cell-production-experts-say'},
    // {id: 2,
    //     title: 'EVEscape: The AI Revolution in Forecasting Viral Variants Before They Emerge',
    //     content: 'New AI tool called EVEscape uses evolutionary and biological information to predict how a virus could change to escape the immune system. ',
    //     image: '/images/general/panel-default-image.svg',
    //     link:'https://scitechdaily.com/evescape-the-ai-revolution-in-forecasting-viral-variants-before-they-emerge/'},
    // {id: 1,
    //     title: 'SANPO: A Scene understanding, Accessibility, Navigation, Pathfinding, & Obstacle avoidance dataset',
    //     content: 'As most people navigate their everyday world, they process visual input from the environment using an eye-level perspective. Unlike robots and self-driving cars, people don\'t have any "out-of-body" sensors to help guide them.',
    //     image: '/images/general/panel-default-image.svg',
    //     link:'https://blog.research.google/2023/10/sanpo-scene-understanding-accessibility.html'},

];

const Homepage = () => {



    return (

        <div
            className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-32">

            <div className="lg:pr-12 lg:place-self-top max-w-lg">
                <div className="flex flex-col ">
                    <svg className="text-blue-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                        <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                    </svg>
                    <div className="h-2"></div>
                    <div className="flex  rounded-lg">
                        <div>
                            <h2 className="text-2xl font-semibold
                                        leading-tight text-gray-800 false">Recent news
                            </h2></div>
                    </div>
                    <div className="h-6"></div>
                    <p className="leading-snug text-gray-500">Some recent events in the world of machine learning
                    </p>
                    <div className="h-6"></div>
                </div>
            </div>

            <div className="container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                {recentNews.map((data) => (
                                     <NewsPanel key={data.id} title={data.title} imageSource={data.image} link={data.link} preview={data.content} comment={data.comment} fontClass="font-open" />
                                 ))}
            </div>
        </div>

    )


}

export default React.memo(Homepage);